'use client';

import { useEffect } from 'react';
import { ShieldAlert, RefreshCcw } from 'lucide-react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Runtime error caught by error.tsx boundary:', error);
  }, [error]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-white px-4">
      <div className="max-w-md w-full text-center space-y-6 p-8 bg-slate-50 rounded-3xl border border-slate-100 shadow-sm">
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto text-red-500 mb-6">
          <ShieldAlert size={40} />
        </div>
        <h2 className="text-2xl font-black text-slate-900">
          Something went wrong
        </h2>
        <p className="text-slate-500 font-medium">
          We apologize for the inconvenience. A technical error has occurred on our end. Please try refreshing the page.
        </p>
        <button
          onClick={() => reset()}
          className="mt-8 flex items-center justify-center gap-2 w-full px-6 py-4 bg-slate-900 hover:bg-slate-800 text-white rounded-xl font-bold transition-all shadow-md hover:-translate-y-0.5"
        >
          <RefreshCcw size={18} /> Try Again
        </button>
      </div>
    </div>
  );
}
